import React from 'react';
import Reveal from '../atoms/reveal';

const FOOTER_LINKS = [
  { icon: 'bxl-facebook-square', label: 'Facebook', href: 'https://www.facebook.com/taiga.kishimoto.14' },
  { icon: 'bxl-twitter', label: 'Twitter', href: 'http://twitter.com/koneko59' },
  { icon: 'bxl-dribbble', label: 'Dribbble', href: '/' },
  { icon: 'bxl-linkedin', label: 'LinkedIn', href: 'http://www.linkedin.com/in/taiga-kishimoto' },
];

function Footer() {
  return (
    <footer>
      <div className="bg-black">
        <div className="flex flex-col justify-center py-6 sm:flex-row">
          <Reveal as="p" className="text-center font-body text-white md:text-left px-6">
            © Taiga Kishimoto
          </Reveal>
          <div className="flex items-center justify-center pt-5 sm:justify-start sm:pt-0 px-6">
            {FOOTER_LINKS.map((link, i) => (
              <Reveal key={link.icon} variant="pop" delay={i * 90} className={i === 0 ? '' : 'pl-4'}>
                <a href={link.href} target="_blank" rel="noopener noreferrer" aria-label={link.label}>
                  <i className={`bounce-icon bx ${link.icon} text-2xl text-white hover:text-yellow`}></i>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;